import { defineStore } from 'pinia';

export const useMetaStore = defineStore('meta', () => {
    const title = ref('');

    return { title };
});
